import { CommonModule as NgCommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FooterModule } from "@obg/core.footer";
import { MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";

import { HeaderModule } from "../../header/header.module";

import { CoreSlimLayoutContainer } from "./core-slim-layout.container";

const DIRECTIVES = [CoreSlimLayoutContainer];

@NgModule({
	imports: [
		NgCommonModule,
		MatCoreModule,
		CoreModule,
		CoreContentModule,
		RouterModule,
		CoreUiModule,
		HeaderModule,
		FooterModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CoreSlimLayoutModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
